export default "__VITE_ASSET__n0kVOZfz__"